const EPCOTLANDS = [
    {
        name: "World Showcase",
        rides: [
            {
                name: 'Canada Far and Wide in Circle-Vision 360',
                count: 0,
            },
            {
                name: 'Frozen Ever After',
                count: 0,
            },
            {
                name: 'Gran Fiesta Tour Starring The Three Caballeros',
                count: 0,
            },
            {
                name: 'Harmonious',
                count: 0,
            },
            {
                name: 'Impressions de France',
                count: 0,
            },
            {
                name: 'JAMMitors',
                count: 0,
            },
            {
                name: "Remy's Ratatouille Adventure",
                count: 0,
            },
            {
                name: 'See Anna and Elsa at Royal Sommerhus',
                count: 0,
            },
            {
                name: 'The American Adventure',
                count: 0,
            }
        ]
    }
]

export default EPCOTLANDS;